import { ReactNode } from 'react';

import { User } from '@/api';

import { CONFIG } from '../config';
import { InvalidRoles } from './invalid-roles.component';
import { Maintenance } from './maintenance.component';
import { VALID_MAINTENANCE_ROLES, VALID_ROLES } from './role.constant';
import { UserProvider } from './user.provider';

interface RoleGuardProps {
  children: ReactNode;
  user: User;
}

export function RoleGuard({ children, user }: RoleGuardProps) {
  const show = {
    invalidRoles: !user.roles.some((role) => VALID_ROLES.includes(role)),
    maintenance:
      CONFIG.MAINTENANCE_MODE === 'true' &&
      !user.roles.some((role) => VALID_MAINTENANCE_ROLES.includes(role)),
  };

  if (show.maintenance) {
    return <Maintenance />;
  }

  if (show.invalidRoles) {
    return <InvalidRoles />;
  }

  return <UserProvider user={user}>{children}</UserProvider>;
}
